import React from 'react';
import './HelpMenuModal.css';

function HelpMenuModal({ open, onClose, onHowToPlay, onHexInfo, onAbout, onPrivacyPolicy }) {
  if (!open) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose} aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7a1 1 0 1 0-1.41 1.41L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z"/>
          </svg>
        </button>

        <h2>Help</h2>
        <p>Select an option:</p>
        <div className="help-menu-buttons">
          <button className="help-menu-button" onClick={onHowToPlay}>
            How to Play
          </button>
          <button className="help-menu-button" onClick={onHexInfo}>
            Understanding Hexadecimal
          </button>
          <button className="help-menu-button" onClick={onAbout}>
            About
          </button>
          <button className="help-menu-button" onClick={onPrivacyPolicy}>
            Privacy Policy
          </button>
        </div>
      </div>
    </div>
  );
}

export default HelpMenuModal;
